// extracted by mini-css-extract-plugin
module.exports = {"gameTags":"_6ac9f20","tag":"_57fd1c6","text":"_a644938","red":"_a6392c1","purple":"_3b70635","blue":"_1462c07","lightGrey":"_b4d3f58","green":"_5e99854"};